import axios from 'axios';

// Helper per ottenere il token di autenticazione salvato (es. in localStorage)
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Configurazione di base per le chiamate API
const api = axios.create({
  baseURL: '/api/courses',
});

// Aggiungiamo il token a ogni richiesta
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Funzione per ottenere tutti i corsi
export const getAllCourses = async () => {
  const response = await api.get('/');
  return response.data;
};

// Funzione per creare un nuovo corso
export const createCourse = async (courseData) => {
  const response = await api.post('/', courseData);
  return response.data;
};

// Funzione per aggiornare un corso esistente
export const updateCourse = async (id, courseData) => {
  const response = await api.put(`/${id}`, courseData);
  return response.data;
};

// Funzione per eliminare un corso
export const deleteCourse = async (id) => {
  await api.delete(`/${id}`);
};